import React from 'react';
import { Card, Stack, Typography } from '@mui/material';
import { Line } from 'react-chartjs-2';
import {
	Chart as ChartJS,
	CategoryScale,
	LinearScale,
	PointElement,
	LineElement,
	Title,
	Tooltip,
	Legend,
	Filler,
} from 'chart.js';
import DataNotFound from '../../../Components/DataNotFound';
import BarChart from '../../../Components/Charts/BarChart';
import LineChart from '../../../Components/Charts/LineChart';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Legend, Filler);

const LineBandGraphCard = ({
	data = [],
	colors = { line: 'rgb(75, 192, 192)', band: 'rgba(75, 192, 192, 0.2)' },
	title = '',
	band = 2,
	height = 300,
}) => {
	console.log('LineBandGraphCard data', data);
	const chartData = {
		labels: data.map((item) => item.label),
		datasets: [
			{
				label: title || 'Dataset',
				data: data.map((item) => item.value),
				fill: false,
				borderColor: colors.line,
				backgroundColor: colors.band,
				tension: 0.5,
				pointRadius: 3,
				pointBackgroundColor: colors.line,
			},
		],
	};

	const options = {
		responsive: true,
		plugins: {
			legend: { display: false },
			bandFill: {
				color: colors.band,
				band: band,
			},
		},
		elements: {
			line: { borderWidth: 2 },
			point: { radius: 3 },
		},
		scales: {
			x: {
      ticks: { display: true }, // show x axis labels
      grid: { display: false, drawBorder: false },
      border: { display: false },
    },
    y: {
      ticks: { display: false }, // hide y axis labels
      grid: { display: false, drawBorder: false },
      border: { display: false },
    },
		},
	};

	return (
		<Card sx={{}}>
			{data.length > 0 ? (
				<>
					<Stack mb={2} direction="row" justifyContent="space-between" px={1} width={'100%'}>
						<Typography textAlign={'center'} fontFamily={'Poppins'} fontSize={14} fontWeight={600} lineHeight={'150%'}>
							{title}
						</Typography>
					</Stack>
					<LineChart data={chartData} options={options} height={height} width={'100%'} scales={options.scales} />
				</>
			) : (
				<Stack mb={2} direction="row" justifyContent="center" alignItems="center" px={1} width={'100%'} height={height}>
					<DataNotFound text="No data available to display the chart." size={100} />
				</Stack>
			)}
		</Card>
	);
};

export default LineBandGraphCard;
